import {v4 as uuidv4} from 'uuid';
import {ProductType} from "./OrderTypes";
import {
Data, LocationEntity, OrderLinesEntity, OrderSubmitType, ProductId, Quantity,
} from "./OrderSubmitType";

// eslint-disable-next-line import/prefer-default-export
export const createOrderRequest = (
    cartItems: ProductType[],
    oTotal: number,
    storeDescription: string,
    storeNumber: string,
    rewardId: number | null,
):
    OrderSubmitType => {
    const submitObject = {} as OrderSubmitType;

    submitObject.precalculatedSubtotal = oTotal;

    const submitLoc = {} as LocationEntity;
    submitLoc.number = storeNumber;
    submitLoc.name = storeDescription;
    submitObject.location = submitLoc;

    const submitData = {} as Data;
    submitData.Status = 'ReadyForValidation'; //TODO check on this
    submitData.TaxExempt = false; //TODO check on this
    const submitOrderLines:OrderLinesEntity[] = [];

    //Parent line creation
    cartItems.forEach((k) => {
        const submitParentOrderLine = {} as OrderLinesEntity;
        const parentLineId = uuidv4();
        submitParentOrderLine.LineId = parentLineId;
        submitParentOrderLine.Description = k.title;

        const parentProductId = {} as ProductId;
        parentProductId.Value = k.productSizeId || k.omsData.salesItems[0].productId;
        submitParentOrderLine.ProductId = parentProductId;

        const parentQuantity = {} as Quantity;
        parentQuantity.Value = k.amount;
        submitParentOrderLine.Quantity = parentQuantity;

        submitParentOrderLine.omsId = k?.omsData?.id;

        //Push the parent
        submitOrderLines.push(submitParentOrderLine);

        //push the children
        if (k.subProducts.length > 0) {
            k.subProducts.forEach((j) => {
                const submitChildOrderLine = {} as OrderLinesEntity;
                submitChildOrderLine.Description = j.name;
                submitChildOrderLine.LineId = uuidv4();
                submitChildOrderLine.ParentLineId = parentLineId;

                const childProductId = {} as ProductId;
                childProductId.Value = j.productId;
                submitChildOrderLine.ProductId = childProductId;

                const childQuantity = {} as Quantity;
                childQuantity.Value = 1;
                submitChildOrderLine.Quantity = childQuantity;

                //Push the parent
                submitOrderLines.push(submitChildOrderLine);
            });
        }
    });

    submitData.OrderLines = submitOrderLines;

    submitObject.reward_ids = rewardId ? [rewardId] : [];

    submitObject.data = submitData;

    return submitObject;
};
